import {useState} from "react";
import {Link} from "react-router-dom";
import type {I18nKey} from "@zaaaz/shared";
import {useI18n} from "./I18nProvider";

type PromoTab = {
  id: string;
  tabKey: I18nKey;
  bodyKey: I18nKey;
  image: string;
  link: string;
  linkKey: I18nKey;
};

const PROMO_TABS: PromoTab[] = [
  {
    id: "store",
    tabKey: "Home promo tabs tab store",
    bodyKey: "Home promo tabs body store",
    image: "/images/home/promo-tab-store.jpg",
    link: "/departments/beauty",
    linkKey: "Home promo tabs link beauty"
  },
  {
    id: "delivery",
    tabKey: "Home promo tabs tab delivery",
    bodyKey: "Home promo tabs body delivery",
    image: "/images/home/promo-tab-delivery.jpg",
    link: "/c/fragrance",
    linkKey: "Home promo tabs link fragrance"
  },
  {
    id: "quality",
    tabKey: "Home promo tabs tab quality",
    bodyKey: "Home promo tabs body quality",
    image: "/images/home/promo-tab-quality.jpg",
    link: "/c/makeup",
    linkKey: "Home promo tabs link makeup"
  }
];

export function HomePromoTabs() {
  const {t} = useI18n();
  const [activeId, setActiveId] = useState(PROMO_TABS[0].id);
  const active = PROMO_TABS.find((tab) => tab.id === activeId) || PROMO_TABS[0];

  return (
    <section className="cc-homePromoTabs" aria-labelledby="home-promo-tabs-title">
      <h2 id="home-promo-tabs-title" className="cc-homePromoTabs__srTitle">{t("Home promo tabs title")}</h2>
      <div className="cc-homePromoTabs__shell">
        <div className="cc-homePromoTabs__nav" role="tablist" aria-label={t("Home promo tabs title")}>
          {PROMO_TABS.map((tab) => {
            const selected = tab.id === activeId;
            return (
              <button
                key={tab.id}
                type="button"
                role="tab"
                id={`home-promo-tab-${tab.id}`}
                aria-selected={selected}
                aria-controls={`home-promo-panel-${tab.id}`}
                className={`cc-homePromoTabs__tab${selected ? " isActive" : ""}`}
                onClick={() => setActiveId(tab.id)}
              >
                {t(tab.tabKey)}
              </button>
            );
          })}
        </div>
        <div
          className="cc-homePromoTabs__panel"
          role="tabpanel"
          id={`home-promo-panel-${active.id}`}
          aria-labelledby={`home-promo-tab-${active.id}`}
        >
          <figure className="cc-homePromoTabs__figure">
            <span className="cc-homePromoTabs__frame" aria-hidden="true" />
            <img src={active.image} alt="" className="cc-homePromoTabs__img" loading="lazy" decoding="async" />
          </figure>
          <div className="cc-homePromoTabs__copy">
            <p className="cc-homePromoTabs__text">{t(active.bodyKey)}</p>
            <Link to={active.link} className="cc-homePromoTabs__link anim">
              {t(active.linkKey)}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
